import { render, staticRenderFns } from "./chooseClassifyDialog.vue?vue&type=template&id=14855bf7"
import script from "./chooseClassifyDialog.vue?vue&type=script&lang=js"
export * from "./chooseClassifyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports